import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequest } from "../apiService/allApi";
import Swal from "sweetalert2";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // 🔹 FORGOT PASSWORD API
    const handleReset = async (e) => {
        e.preventDefault();
        setLoading(true);

        const requestData = {
            email: email,
        };

        try {
            const response = await apiRequest(
                "api/customer/forget-password",
                "Put",
                requestData
            );

            if (response?.data?.status === "success") {
                Swal.fire({
                    icon: "success",
                    text: response?.data?.message,
                });

                navigate("/login"); // Navigate back to login
            }
        } catch (e) {
            console.log(e);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: e.response?.data?.message || "Failed to send reset link",
            });
        } finally {
            setLoading(false);
        }
    };

    return (

<div className="container">
        <div className="row justify-content-center">
            <div className="col-lg-4">
                <div className="auth-box">
                    <h2>Forgot Password</h2>
                    <hr/>

                      <div className="text-center authbox-1">

            <h6>Welcome Back</h6>
            <p>Enter your Email Id and password to proceed</p>
      </div>

                    <form onSubmit={handleReset}>
                        <input
                            type="email"
                            placeholder="Enter registered email"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />

                    
<div className="d-flex justify-content-center">
                         <button
  className="common_blackButton__CWUUs"
  type="submit"
  disabled={loading}
>
  {loading ? "Sending..." : "Send Reset Link"}
</button>


                          </div>
                    </form>

                    <div className="auth-link">
                        <Link to="/login">Back to Login</Link>
                    </div>
                </div>
            </div>
        </div>

</div>
    );
}

export default ForgotPassword;
